import { useFormContext, useFormState } from "react-hook-form";
import { useQuery } from "@tanstack/react-query";
import FormInputText from "../../shared/FormInputText";
import FormSelect from "../../shared/FormSelect";
import FormCheckbox from "../../shared/FormCheckbox";
import { getAccountTypes } from '../../../utils/apiUtils';
import { SUB_ACCOUNT_DRAFT } from "../../../utils/constants";

const step = 1;
const SubAccountStepOne = ({ activeStep }) => {
    const { control, register, getValues } = useFormContext();
    const { errors } = useFormState({ control });

    const { data: accountTypes } = useQuery({
        queryKey: ['getAccountTypes'],
        queryFn: () => getAccountTypes(),
        select: (data) => data?.rows.filter(row => row.accountTypeCode.includes('AT')).map((entry) => {
            return { value: entry.accountTypeCode, label: entry.accountTypeDesc }})
    });

    if (activeStep !== step) return null;

    const topAccount = getValues();
    const subAccounts = topAccount.subAccounts ?? [];
    const subAccountDraft = getValues(SUB_ACCOUNT_DRAFT);

    const allAccountsInScope = [topAccount, ...subAccounts]
        .filter(a => {
            return a.accountHccId && a.accountName && a.accountId !== subAccountDraft.accountId
        })
        .map(account => ({
            key: account.accountId,
            value: account.accountHccId,
            label: `${account.accountName} (${account.accountHccId})`,
        }));

    return (
        <div style={{ width: "50%" }}>
            <FormSelect
                label={'Parent Account'}
                name={`${SUB_ACCOUNT_DRAFT}.parentAccount`}
                control={control}
                options={allAccountsInScope}
                errors={errors}
                placeholder="Parent account"
            />
            <FormInputText label={'Account Name'} register={register} name={`${SUB_ACCOUNT_DRAFT}.accountName`} errors={errors} placeholder="Account name" />
            <FormInputText label={'Account HCC ID'} register={register} name={`${SUB_ACCOUNT_DRAFT}.accountHccId`} errors={errors} placeholder="HCC ID" />
            <FormSelect
                label={'Account Type'}
                name={`${SUB_ACCOUNT_DRAFT}.accountType`}
                control={control}
                options={accountTypes}
                errors={errors}
                placeholder="Account type"
            />
            <FormCheckbox
                label={'Subscriptions Allowed'}
                name={`${SUB_ACCOUNT_DRAFT}.subscriptionsAllowed`}
                control={control}
            />
        </div>
    );
};

export default SubAccountStepOne;
